import { Autocomplete, Card, Grid, MenuItem, Stack, TextField } from '@mui/material';
import { IViaDanhMuc, IViaServiceItem } from '../../../../@types/service';
import { useEffect, useState } from 'react';
import { useSelector } from 'redux/store';
import { TypeService } from 'utils/constant';

export interface IViaServiceCardItemProps {
  onChange: (item: IViaServiceItem) => void;
  item: IViaServiceItem;
}

export default function ViaServiceCardItem({ onChange, item }: IViaServiceCardItemProps) {
  const { danhMucs, servers } = useSelector((state) => state.service);
  const [server, setServer] = useState<string>(item.server);
  const [danhMuc, setDanhMuc] = useState<string>(item.service);
  const [dms, setDms] = useState<IViaDanhMuc[]>([]);

  useEffect(() => {
    onChange({ server, service: danhMuc });
  }, [server, danhMuc]);

  useEffect(() => {
    setDms(danhMucs.filter((f) => f.server === server));
  }, [server]);

  return (
    <Card sx={{ p: 2 }}>
      <Stack spacing={1}>
        <TextField
          label="server"
          size="small"
          InputLabelProps={{ shrink: true }}
          SelectProps={{ native: false, sx: { textTransform: 'capitalize' } }}
          select
          fullWidth
          value={server}
          onChange={(e) => setServer(e.target.value)}
        >
          {servers
            .filter((f) => f.serverType === TypeService.Via)
            .map((server) => (
              <MenuItem key={server.id} value={server.id}>
                {server.displayname}
              </MenuItem>
            ))}
        </TextField>
        <TextField
          label="Danh mục"
          size="small"
          InputLabelProps={{ shrink: true }}
          SelectProps={{ native: false, sx: { textTransform: 'capitalize' } }}
          select
          fullWidth
          value={danhMuc}
          onChange={(e) => setDanhMuc(e.target.value)}
        >
          {dms.map((dm) => (
            <MenuItem key={dm.maDanhMuc} value={dm.maDanhMuc}>
              {dm.tenDanhMuc}
            </MenuItem>
          ))}
        </TextField>
      </Stack>
    </Card>
  );
}
